module.exports = __webpack_public_path__ + "img/tableau-complexe.bfb24785.svg";